import { render } from "./edit_post copy.vue?vue&type=template&id=14087350"
import script from "./edit_post copy.vue?vue&type=script&lang=js"
export * from "./edit_post copy.vue?vue&type=script&lang=js"

import "./edit_post copy.vue?vue&type=style&index=0&id=14087350&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_business_web\\seller.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__